export default __webpack_public_path__ + "static/media/unifreiburg.7eaec9ba.png";